import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(cleanupInviteAFriendModal),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadReferralCampaign);

import { fetchEntity } from '@classpass/saga-tools';
import * as logger from 'universal-logger';
import { all, call } from 'redux-saga/effects';
import { scheduleById, userActionCampaignEvent } from 'redux/saga/entities/bound';
import { resetEntity } from 'redux/saga/helpers/reset-entity';
export function cleanupInviteAFriendModal() {
  return regeneratorRuntime.wrap(function cleanupInviteAFriendModal$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([call(resetEntity, scheduleById), call(resetEntity, userActionCampaignEvent)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function loadReferralCampaign(client, _ref) {
  var scheduleId, reservationId;
  return regeneratorRuntime.wrap(function loadReferralCampaign$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          scheduleId = _ref.scheduleId, reservationId = _ref.reservationId;
          _context2.prev = 1;
          _context2.next = 4;
          return all([call(fetchEntity, scheduleById, [client, scheduleId]), call(fetchEntity, userActionCampaignEvent, [client, 'ReservationSuccess', {
            id: reservationId,
            ignore_cooldown: true
          }])]);

        case 4:
          _context2.next = 10;
          break;

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 10;
          return call(logger.warn, 'Could not load Invite-A-Friend modal data', _context2.t0);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 6]]);
}